<template>    
    <div class="flex flex-row align-items-start gap-2 xl:flex-row lg:flex-row md:flex-row px-3 py-2"
        :class="(screenSize === 'xs' || screenSize === 'sm') ? 'overflow-x-scroll' : ''">
        <SelectButton v-model="set" :options="sets" optionLabel="name" multiple aria-labelledby="multiple">
            <template #option="slotProps">
                <span class="text-xs py-1 white-space-nowrap">{{ slotProps.option.name }}</span>
            </template>
        </SelectButton>
        <Button :label="(screenSize === 'xs' || screenSize === 'sm') ? '' : 'Сбросить'" 
            icon="pi pi-filter" size="small" @click="resetFilter" text severity="info" class="mt-1"/>
        <Button v-if="isUserInGroup('admin')"
            :label="(screenSize === 'xs' || screenSize === 'sm') ? '' : 'Добавить'" 
            icon="pi pi-plus" size="small" @click="popupAddRate" text severity="info" class="mt-1"/>
    </div>

    <DataTable v-if='rates && !loadingRates' responsiveLayout="scroll" ref="dt" dataKey="id"
        :value="rates" v-model:first="skip" v-model:filters="filters"
        :rows="lazyParams.rows" :rowsPerPageOptions="[20, 50, 100]" :totalRecords="totalRates" paginator
        @page="onPage($event)" @sort="onSort($event)" :loading="loadingRates" 
        @filter="onFilter($event)"  filterDisplay="menu" 
        :globalFilterFields="['id', 'type', 'from_currency_code', 'to_currency_code', 'stock_type', 'from', 'to']" >

        <Column field="id" header="" filterMatchMode="contains" :showFilterMenu="true" :showFilterMatchModes="false">
            <template #header>
            <span class="text-xs">ID</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <InputText type="text" v-model="filterModel.value" @keydown.enter="filterCallback()"
                    class="p-column-filter w-12rem" placeholder="Найти" />
            </template>
            <template #body="{ data }">
                <span class="text-sm flex flex-row" @click="copy(data.id)">
                    <span class="flex text-xs">{{get_short_id(data.id)}}</span>
                    <span class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
                </span>
            </template>
        </Column>

        <Column field="active" header="" :showFilterMenu="true" :showFilterMatchModes="false">
            <template #header>
                <span class="text-xs">Акт.</span>
            </template>
            <template #body="{ data }">
                <div class="flex flex-row align-items-center gap-2" >
                    <span class="text-white font-medium text-xs p-1 border-round-md" :class="(data.active) ? 'surface-500' : 'bg-orange-400'">
                        {{ (data.active) ? 'да' : 'нет' }}
                    </span>
                    <div v-if="(isUserInGroup('admin') || isUserInGroup('manager')) && data.id" class="mb-2 xl:mb-0 lg:mb-0 md:md-0">
                        <Button icon="pi pi-pencil" iconPos="right" @click='EditActive(data.id)' size="small" class="border-round-md text-sm" :disabled="loadingChanges" severity="info"/>
                    </div>
                </div>
            </template>
        </Column>

        <Column field="type" header="" :showFilterMenu="true" :showFilterMatchModes="false">
            <template #header>
                <span class="text-xs">Тип</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <Select v-model="filterModel.value" @change="filterCallback()" :options="types" placeholder="Все" class="p-column-filter" :showClear="true">
                    <template #option="slotProps">
                        <div class="inline-block py-1 px-2 text-xs border-round-md font-semibold surface-300 cursor-pointer font-medium align-items-center" >
                            <span class="flex">{{slotProps.option}}</span>
                        </div>
                    </template>
                </Select>
            </template>
            <template #body="{ data }">
                <span class="text-white font-medium text-xs p-1 border-round-md"
                    :class="(data.type=='origin') ? 'bg-green-300' : (data.type=='calculated') ? 'bg-primary' : 'surface-500'">
                    {{ data.type }}
                </span>
            </template>
        </Column>

        <Column field="from_currency_code" header="" :showFilterMenu="true" :showFilterMatchModes="false">
            <template #header>
                <span class="text-xs">From</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <Select v-model="filterModel.value" @change="filterCallback()" :options="currenciesCodes" placeholder="Все" class="p-column-filter uppercase" :showClear="true" filter>
                    <template #option="slotProps">
                        <div class="inline-block py-1 px-2 text-xs border-round-md font-semibold surface-300 cursor-pointer font-medium align-items-center" >
                            <span class="flex uppercase">{{slotProps.option}}</span>
                        </div>
                    </template>
                </Select>
            </template>
            <template #body="{ data }">
                <div class="flex flex-row align-items-center gap-2" >
                    <AvatarGroup v-if="data.from_currency_code">
                        <Avatar :image="getCurImage(data.from_currency_code)" class="surface-0 border-2 border-100" shape="circle"/>
                    </AvatarGroup>
                    <p class="text-xs white-space-nowrap m-0 uppercase">
                        {{ (data.from_currency_code) ? data.from_currency_code : '–'}}
                    </p>
                </div>
            </template>
        </Column>

        <Column field="to_currency_code" header="" :showFilterMenu="true" :showFilterMatchModes="false">
            <template #header>
                <span class="text-xs">To</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <Select v-model="filterModel.value" @change="filterCallback()" :options="currenciesCodes" placeholder="Все" class="p-column-filter uppercase" :showClear="true" filter>
                    <template #option="slotProps">
                        <div class="inline-block py-1 px-2 text-xs border-round-md font-semibold surface-300 cursor-pointer font-medium align-items-center" >
                            <span class="flex uppercase">{{slotProps.option}}</span>
                        </div>
                    </template>
                </Select>
            </template>
            <template #body="{ data }">
                <div class="flex flex-row align-items-center gap-2" >
                    <AvatarGroup v-if="data.to_currency_code">
                        <Avatar :image="getCurImage(data.to_currency_code)" class="surface-0  border-2 border-100" shape="circle"/>
                    </AvatarGroup>
                    <p class="text-xs white-space-nowrap m-0 uppercase">
                        {{ (data.to_currency_code) ? data.to_currency_code : '–'}}
                    </p>
                </div>
            </template>
        </Column>

        <Column field="stock_type" :showFilterMenu="true" :showFilterMatchModes="false" v-if="selectedColumns.includes('Парсинг')">
            <template #header>
                <span class="text-xs">Парсинг</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <Select v-model="filterModel.value" @change="filterCallback()" :options="types_of_stock" placeholder="Все" class="p-column-filter" :showClear="true">
                    <template #option="slotProps">
                        <div class="inline-block py-1 px-2 text-xs border-round-md font-semibold surface-300 cursor-pointer font-medium align-items-center" >
                            <span class="flex">{{slotProps.option}}</span>
                        </div>
                    </template>
                </Select>
            </template>
            <template #body="{ data }">
                <div class="flex flex-row align-items-center gap-2" >
                    <span class="flex text-white font-medium text-xs p-1 border-round-md surface-500"
                        :class="(data.stock.type=='regular' || data.stock.type=='manual') ? 'surface-500' : (data.stock.type=='binance' || data.stock.type=='bybit' || data.stock.type=='htx') ? 'bg-orange-400' : 'surface-500'">
                        {{ data.stock.type }}
                    </span>
                    <span class="flex text-600 font-medium text-xs">
                        {{ data.stock.period }}
                    </span>
                    <div v-if="(isUserInGroup('admin') || isUserInGroup('manager'))" class="mb-2 xl:mb-0 lg:mb-0 md:md-0">
                        <Button icon="pi pi-pencil" iconPos="right" @click='EditStock(data.id)' size="small" class="border-round-md text-sm" :disabled="loadingChanges" severity="info"/>
                    </div>
                </div>
            </template>
        </Column>

        <Column field="rate_origin">
            <template #header>
                <span class="text-xs">Курс парсинга</span>
            </template>
            <template #body="{ data }">
                <p class="text-xs white-space-nowrap m-0">
                    <span class="font-medium">{{ data.rate_origin}}</span> <br>
                    <span v-if="getReverceRate(data.rate_origin)">{{ getReverceRate(data.rate_origin)}}</span>
                </p>
            </template>
        </Column>

        <Column field="exchange_percent">
            <template #header>
                <span class="text-xs">Обменный&nbsp%</span>
            </template>
            <template #body="{ data }">
                <p class="text-xs font-medium white-space-nowrap m-0"
                    :class="(getExchangePercent(data) >= 0) ? 'text-green-500':'text-orange-500'" >
                    {{ getExchangePercent(data) }}
                </p>
            </template>
        </Column>

        <Column field="rate">
            <template #header>
                <span class="text-xs">Обменный курс</span>
            </template>
            <template #body="{ data }">
                <div class="flex flex-row align-items-center gap-3" >
                    <p class="text-xs white-space-nowrap m-0">
                        <span class="font-medium">{{ getExchangeRate(data)}}</span> <br>
                        <span v-if="getReverceRate(getExchangeRate(data))">{{ getReverceRate(getExchangeRate(data))}}</span>
                    </p>
                    <div v-if="(isUserInGroup('admin') || isUserInGroup('manager')) && data.id && data.type && data.type=='origin'" class="mb-2 xl:mb-0 lg:mb-0 md:md-0">
                        <Button icon="pi pi-pencil" iconPos="right" @click='EditRate(data.id)' size="small" class="border-round-md text-sm" :disabled="loadingChanges" severity="info"/>
                    </div>
                </div>
            </template>
        </Column>

        <Column field="rate">
            <template #header>
                <span class="text-xs">Курс для клиента</span>
            </template>
            <template #body="{ data }">
                <div v-if="data.type && data.type !== 'nulled'" class="flex flex-column text-xs white-space-nowrap gap-1">
                    <span class="flex">Перевод: {{ getClientRate(data, 'transfer') }}</span>
                    <span class="flex">Пополнение: {{ getClientRate(data, 'topup') }}</span>
                    <span class="flex">Вывод: {{ getClientRate(data, 'withdraw') }}</span>
                    <span class="flex">Счет: {{ getClientRate(data, 'bill') }}</span>
                    <span v-if="data.type=='origin' && data.to_currency_code=='usdt'" class="flex">Пополнение: {{ getClientRate(data, 'topup') }}</span>
                </div>
            </template>
        </Column>
        
        <Column field="pays_get_codes" v-if="selectedColumns.includes('Платежки')">
            <template #header>
                <span class="text-xs">Платежки приема</span>
            </template>
            <template #body="{ data }">
                <div class="flex flex-row align-items-center gap-2" >
                    <div v-if="data.pays_get_codes && data.pays_get_codes.length >= 0"
                        v-for="code of data.pays_get_codes" :key="code"
                        class="flex flex-row align-items-center text-xs" >
                        {{ code }}
                    </div>
                    <div v-if="(isUserInGroup('admin') || isUserInGroup('manager')) && data.id" class="mb-2 xl:mb-0 lg:mb-0 md:md-0">
                        <Button icon="pi pi-pencil" iconPos="right" @click='EditPaySystems(data.id)' size="small" class="border-round-md text-sm" :disabled="loadingChanges" severity="info"/>
                    </div>
                </div>
            </template>
        </Column>

        <Column field="pays_get_codes" v-if="selectedColumns.includes('Платежки')">
            <template #header>
                <span class="text-xs">Платежки выплаты</span>
            </template>
            <template #body="{ data }">
                <div class="flex flex-row align-items-center gap-2" >
                    <div v-if="data.pays_send_codes && data.pays_send_codes.length >= 0"
                        v-for="code of data.pays_send_codes" :key="code"
                        class="flex flex-row align-items-center text-xs" >
                        {{ code }}
                    </div>
                </div>
            </template>
        </Column>

        <Column field="get_bank_codes" v-if="selectedColumns.includes('Банки')">
            <template #header>
                <span class="text-xs">Банки приема</span>
            </template>
            <template #body="{ data }">
                <div class="flex flex-row align-items-center" v-if="data.get_bank_codes && data.get_bank_codes.length >= 0">
                    <BanksEditor :id="data.id" :bank_codes="data.get_bank_codes" type="get" :filter="{currency_code: data.from_currency_code, active: true}"
                        @update="UpdateBanks" :close="closeBanks"/> 
                </div>
            </template>
        </Column>

        <Column field="get_bank_codes" v-if="selectedColumns.includes('Банки')">
            <template #header>
                <span class="text-xs">Банки выплаты</span>
            </template>
            <template #body="{ data }">
                <div class="flex flex-row align-items-center" v-if="data.send_bank_codes && data.send_bank_codes.length >= 0">
                    <p class="text-sm white-space-nowrap mr-2 p-2 align-items-center">
                        <span class="font-medium">{{ data.send_bank_codes.length}}</span>
                    </p>
                    <BanksEditor :id="data.id" :bank_codes="data.send_bank_codes" type="send" :filter="{currency_code: data.to_currency_code, active: true}"
                        @update="UpdateBanks" :close="closeBanks"/> 
                </div>
            </template>
        </Column>

        <Column field="free_limit" header="" v-if="selectedColumns.includes('Лимиты')">
            <template #header>
                <span class="text-xs">Первый перевод</span>
            </template>
            <template #body="{ data }">
                <p class="text-xs white-space-nowrap m-0" v-if="data.limits && data.limits.transfer && data.limits.transfer.free!=undefined">
                    {{ get_format_amount(data.limits.transfer.free, data.from_currency_code) }}
                </p>
            </template>
        </Column>

        <Column field="limits" v-if="selectedColumns.includes('Лимиты')" >
            <template #header>
                <span class="text-xs">Лимиты</span>
            </template>
            <template #body="{ data }">
                <div class="flex flex-row align-items-center gap-3" >
                    <div class="flex flex-column gap-1">
                        <small class="flex text-xs white-space-nowrap" v-if="data.limits && data.limits.transfer">
                            Перевод: {{ get_format_amount(data.limits.transfer.min, data.from_currency_code) }} - {{ get_format_amount(data.limits.transfer.max, data.from_currency_code) }}
                        </small>
                        <small class="flex text-xs white-space-nowrap" v-if="data.limits && data.limits.bill">
                            Счет: {{ get_format_amount(data.limits.bill.min, data.from_currency_code) }} - {{ get_format_amount(data.limits.bill.max, data.from_currency_code) }}
                        </small>
                        <small class="flex text-xs white-space-nowrap" v-if="data.limits && data.limits.payment">
                            Оплата: {{ get_format_amount(data.limits.payment.min, data.from_currency_code) }} - {{ get_format_amount(data.limits.payment.max, data.from_currency_code) }}
                        </small>
                        <small class="flex text-xs white-space-nowrap" v-if="data.limits && data.limits.topup && (data.limits.topup.min != undefined || data.limits.topup.max != undefined)">
                            Пополнение: {{ get_format_amount(data.limits.topup.min, data.from_currency_code) }} - {{ get_format_amount(data.limits.topup.max, data.from_currency_code) }}
                        </small>
                    </div>
                    <div v-if="(isUserInGroup('admin') || isUserInGroup('manager'))" class="flex mb-2 xl:mb-0 lg:mb-0 md:md-0">
                        <Button icon="pi pi-pencil" iconPos="right" @click='EditLimits(data.id)' size="small" class="border-round-md text-sm" :disabled="loadingChanges" severity="info"/>
                    </div>
                </div>
            </template>
        </Column>

        <Column field="limits" v-if="selectedColumns.includes('Комиссии')">
            <template #header>
                <span class="text-xs">Комиссии</span>
            </template>
            <template #body="{ data }">
                <div class="flex flex-row align-items-center gap-3" >
                    <div class="flex flex-column gap-1">
                        <small class="text-xs white-space-nowrap m-0" v-if="data.coms && data.coms.transfer">
                            Перевод: {{ getFormatPercent(data.coms.transfer) }}
                        </small>
                        <small class="text-xs white-space-nowrap m-0" v-if="data.coms && data.coms.bill">
                            Счет: {{ getFormatPercent(data.coms.bill) }}
                        </small>
                        <small class="text-xs white-space-nowrap m-0" v-if="data.coms && data.coms.payment">
                            Оплата: {{ getFormatPercent(data.coms.payment) }}
                        </small>
                        <small class="text-xs white-space-nowrap m-0" v-if="data.coms && data.coms.topup">
                            Пополнение: {{ getFormatPercent(data.coms.topup) }}
                        </small>
                    </div>
                    <div v-if="(isUserInGroup('admin') || isUserInGroup('manager'))" class="flex mb-2 xl:mb-0 lg:mb-0 md:md-0">
                        <Button icon="pi pi-pencil" iconPos="right" @click='EditComs(data.id)' size="small" class="border-round-md text-sm" :disabled="loadingChanges" severity="info"/>
                    </div>
                </div>
            </template>
        </Column>

        <Column field="percents" header="" v-if="selectedColumns.includes('Комиссии')">
            <template #header>
                <span class="text-xs">Комиссии (прм/выпл/срв)</span>
            </template>
            <template #body="{ data }">
                <div class="flex flex-row align-items-center gap-3" >
                    <div class="flex flex-column gap-1">
                        <small class="flex text-xs white-space-nowrap m-0">
                            Перевод: {{ getFormatCom(data, 'transfer', 'get') }} /
                            {{ getFormatCom(data, 'transfer', 'send') }}
                        </small>
                        <small v-if="data.type=='origin' && data.to_currency_code=='usdt'" 
                            class="flex text-xs white-space-nowrap m-0">
                            Пополнение: {{ getFormatCom(data, 'topup', 'get') }} /
                            {{ getFormatCom(data, 'topup', 'send') }}
                        </small>
                        <small v-if="data.type=='origin' && data.from_currency_code=='usdt'" 
                            class="flex text-xs white-space-nowrap m-0">
                            Вывод: {{ getFormatCom(data, 'withdraw', 'get') }} /
                            {{ getFormatCom(data, 'withdraw', 'send') }}
                        </small>
                        <small class="flex text-xs white-space-nowrap m-0">
                            Счет: {{ getFormatCom(data, 'bill', 'get') }} /
                            {{ getFormatCom(data, 'bill', 'send') }} 
                        </small>
                    </div>
                </div>
            </template>
        </Column>

        <Column field="date_update" header="" :exportable="false" sortable filterField="date_update" dataType="date" :showFilterMatchModes="true">
            <template #header>
            <span class="text-xs">Обновлен</span>
            </template>
            <template #body="{ data }">
                <small class="text-xs">{{ formatDate(data.date_update) }}</small>
            </template>
        </Column>

        <template #footer>
            <span class="text-sm font-medium">
                Всего {{ totalRates }} курсов
            </span>
        </template>

    </DataTable>

    <div class="flex flex-column align-items-center justify-content-center mt-3 px-2">
        <Skeleton height="2rem" v-if="loadingRates" />
    </div>

    <!--ДОБАВИТЬ КУРС-->
    <Dialog v-if="(isUserInGroup('admin') || isUserInGroup('manager'))" class="flex flex-column border-none" modal
        v-model:visible="popupAdd"
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : ''">

        <template #header>
            <div class="flex flex-column w-full mb-3">
                <span class="flex text-lg font-medium">Добавить новый курс</span>
            </div>
        </template>

        <div v-if="currentRate" class="flex flex-column w-full gap-3" style="min-width: 300px;">
            <div class="flex flex-column w-full">
                <span class="flex mr-2 mb-1">Тип курса: </span>
                <Select v-model="currentRate.type" :options="types" placeholder="Тип курса" 
                    class="flex w-full"/>
            </div>
            <div class="flex flex-column w-full">
                <span class="flex mr-2 mb-1">Валюта приема: </span>
                <Select v-model="currentRate.from_currency_code" :options="currencies" :disabled="!currentRate.type || currentRate.type==='nulled'"
                    placeholder="Валюта приема" optionLabel="code" optionValue="code" filter class="flex w-full">
                    <template #value="slotProps">
                        <div v-if="slotProps.value" class="flex align-items-center">
                            <img :src="getCurImage(slotProps.value)" class="mr-2 w-3 border-200 border-1 border-circle" style="max-width: 22px;" />
                            <span class="flex uppercase ml-2">{{slotProps.value}}</span>
                        </div>
                        <span v-else>
                            {{ slotProps.placeholder }}
                        </span>
                    </template>
                    <template #option="slotProps">
                        <div class="flex align-items-center">
                            <img v-if="slotProps.option.code" :src="getCurImage(slotProps.option.code)" class="mr-2 w-3 border-200 border-1 border-circle" style="max-width: 22px;" />
                            <span class="flex uppercase ml-2">{{slotProps.option.code}}</span>
                        </div>
                    </template>
                </Select>
            </div>
            <div class="flex flex-column w-full">
                <span class="flex mr-2 mb-1">Валюта выплаты: </span>
                <Select v-model="currentRate.to_currency_code" :options="currencies" :disabled="!currentRate.type"
                    placeholder="Валюта выплаты" optionLabel="code" optionValue="code" filter class="flex w-full">
                    <template #value="slotProps">
                        <div v-if="slotProps.value" class="flex align-items-center">
                            <img :src="getCurImage(slotProps.value)" class="mr-2 w-3 border-200 border-1 border-circle" style="max-width: 22px;" />
                            <span class="flex uppercase ml-2">{{slotProps.value}}</span>
                        </div>
                        <span v-else>
                            {{ slotProps.placeholder }}
                        </span>
                    </template>
                    <template #option="slotProps">
                        <div class="flex align-items-center">
                            <img v-if="slotProps.option.code" :src="getCurImage(slotProps.option.code)" class="mr-2 w-3 border-200 border-1 border-circle" style="max-width: 22px;" />
                            <span class="flex uppercase ml-2">{{slotProps.option.code}}</span>
                        </div>
                    </template>
                </Select>
            </div>
            <div class="flex flex-column w-full">
                <span class="flex mr-2 mb-1">Курс: </span>
                <InputNumber v-model="currentRate.rate" mode="decimal" :minFractionDigits="2" :maxFractionDigits="6" class="flex w-full" placeholder="Курс"/>
            </div>
        </div>

        <template #footer>
            <div class="w-full mb-3 flex justify-content-between flex-wrap">
                <Button label="Добавить" icon="pi pi-check" iconPos="right" @click='AddRate()' :loading="loadingChanges" class="flex"
                    :disabled="loadingChanges || !currentRate.type"/>
                <Button label="Закрыть" icon="pi pi-times" @click="closeDialog" outlined class="flex" autofocus severity="secondary" :loading="loadingChanges" :disabled="loadingChanges"/>
            </div>
        </template>
    </Dialog>

    <!--ИЗМЕНИТЬ ПАРСИНГ-->
    <Dialog v-if="(isUserInGroup('admin') || isUserInGroup('manager'))" class="flex flex-column border-none" modal
        v-model:visible="popupStock"
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : ''">

        <template #header>
            <div class="flex flex-column w-full mb-3" v-if="currentRate">
                <span class="flex text-lg font-medium">Редактировать парсинг {{currentRate.from_currency_code}} → {{currentRate.to_currency_code}}</span>
            </div>
        </template>

        <div class="flex flex-column w-full gap-3 max-w-30rem" v-if="currentRate">
            <div class="flex flex-column w-full">
                <span class="flex mr-2 mb-1">Тип парсинга: </span>
                <Select v-model="currentRate.stock.type" :options="stockTypes" placeholder="Парсер" class="flex" optionLabel="label" optionValue="value" />
            </div>
            <div class="flex flex-column w-full">
                <span class="flex mr-2 mb-1">Период парсинга: </span>
                <Select v-model="currentRate.stock.period" :options="stockPeriods" placeholder="Период" class="flex" optionLabel="label" optionValue="value" />
            </div>
            <div class="flex flex-column w-full gap-1">
                <span class="flex mr-2">Свойства: </span>
                <Textarea v-model="formatedStockProps" :rows="15" :cols="30" class="flex" :autoResize="true" :disabled="false"/>
                <div class="flex flex-row gap-2">
                    <span class="flex text-primary cursor-pointer mt-2" @click="setStockTemplate('bybit')">#Bybit</span>
                    <span class="flex text-primary cursor-pointer mt-2" @click="setStockTemplate('binance')">#Binance</span>
                    <span class="flex text-primary cursor-pointer mt-2" @click="setStockTemplate('htx')">#HTX</span>
                </div>
                <span class="text-xs w-full surface-100 p-2 border-round-lg line-height-2" v-html="stockDesc"></span>
            </div>
        </div>
        <template #footer>
            <div class="w-full mb-3 flex justify-content-between flex-wrap">
                <Button label="Изменить" icon="pi pi-check" iconPos="right" @click='UpdateStock()' :loading="loadingChanges" :disabled="loadingChanges" class="flex"/>
                <Button label="Закрыть" icon="pi pi-times" @click="closeDialog" outlined class="flex" autofocus severity="secondary" :loading="loadingChanges" :disabled="loadingChanges"/>
            </div>
        </template>
    </Dialog>

    <!--ИЗМЕНИТЬ АКТИВНОСТЬ-->
    <Dialog v-if="(isUserInGroup('admin') || isUserInGroup('manager'))" class="flex flex-column border-none" modal
        v-model:visible="popupActive"
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : ''">

        <template #header>
            <div class="flex flex-column w-full mb-3" v-if="currentRate">
                <span class="flex text-lg font-medium">Редактировать активность курса {{currentRate.from_currency_code}} → {{currentRate.to_currency_code}}</span>
            </div>
        </template>

        <div class="flex flex-column w-full gap-3">
            <div class="flex flex-column w-full">
                <SelectButton v-model="currentRate.active" :options="active_options" aria-labelledby="basic" class="flex" optionLabel="label" optionValue="value" />
            </div>
        </div>

        <template #footer>
            <div class="w-full mb-3 flex justify-content-between flex-wrap">
                <Button label="Изменить" icon="pi pi-check" iconPos="right" @click='UpdateActive()' :loading="loadingChanges" :disabled="loadingChanges" class="flex"/>
                <Button label="Закрыть" icon="pi pi-times" @click="closeDialog" outlined class="flex" autofocus severity="secondary" :loading="loadingChanges" :disabled="loadingChanges"/>
            </div>
        </template>
    </Dialog>

    <!--ИЗМЕНИТЬ КУРС-->
    <Dialog v-if="(isUserInGroup('admin') || isUserInGroup('manager'))" header="Редактировать курс" class="flex flex-column border-none" modal
        v-model:visible="popupRates" 
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : 'max-w-30rem'">

        <template #header>
            <div class="flex flex-column w-full mb-3" v-if="currentRate">
                <span class="flex text-lg font-medium">Редактировать курс {{currentRate.from_currency_code}} → {{currentRate.to_currency_code}}</span>
            </div>
        </template>
        
        <div class="flex flex-column w-full mb-3" v-if="currentRate && currentRate.rate_origin != undefined">
            <span class="flex text-sm mr-2 mb-1">Текущий оригинальный курс: </span>
            <span class="flex text-700 font-medium white-space-nowrap m-0">
                <span class="text-md mr-2">{{ currentRate.rate_origin }}</span>
                <span>({{getReverceRate(currentRate.rate_origin)}})</span>
            </span>
        </div>
        <div class="flex flex-column w-full mb-3" v-if="currentRate && currentRate.rate != undefined">
            <span class="flex text-sm mr-2 mb-1">Текущий обменный курс: </span>
            <span class="flex text-700 font-medium white-space-nowrap m-0">
                <span class="text-md mr-2">{{ currentRate.rate }}</span>
                <span>({{getReverceRate(currentRate.rate)}})</span>
            </span>
        </div>
        <div class="flex flex-row gap-3">
            <div class="flex flex-column w-full mb-3" v-if="currentRate && currentRate.exchange_percent != undefined">
                <span class="flex text-sm mr-2 mb-1">Текущий процент: </span>
                <span class="flex text-700 font-medium white-space-nowrap m-0">
                    <span class="text-md mr-2" :class="(currentRate.exchange_percent >= 0) ? 'text-green-500':'text-orange-500'">
                        {{ currentRate.exchange_percent }}
                    </span>
                </span>
            </div>

            <div class="flex flex-column w-full mb-3" v-if="currentPercent != undefined">
                <span class="flex text-sm mr-2 mb-1">Новый процент: </span>
                <span class="flex text-700 font-medium white-space-nowrap m-0">
                    <span class="text-md mr-2" :class="(currentPercent >= 0) ? 'text-green-500':'text-orange-500'">
                        {{ currentPercent }}
                    </span>
                </span>
            </div>
        </div>

        <div class="flex flex-column w-full mb-3" v-if="currentRate && currentRate.exchange_percent != undefined">
            <span class="flex text-sm mr-2 mb-1">Знак увеличения/уменьшения: </span>
            <SelectButton v-model="currentSign" :options="percent_signs" aria-labelledby="basic" class="flex" :disabled="true"/>
        </div>
        <!-- <div class="flex flex-column w-full mb-3" v-if="currentRate && currentRate.exchange_percent != undefined">
            <span class="flex text-sm mr-2 mb-1">Новый процент: </span>
            <InputNumber v-model="currentPercent" :minFractionDigits="1" :maxFractionDigits="9" locale="en-US" :step="0.0001" :disabled="true" />
        </div> -->
        <div class="flex flex-column w-full mb-3" v-if="currentRate && currentRate.exchange_percent != undefined">
            <span class="flex text-sm mr-2 mb-1">Новый обм. инвертированный курс: </span>
            <InputNumber v-model="newRecalcRateInvert" :minFractionDigits="1" :maxFractionDigits="9" locale="en-US" showButtons buttonLayout="horizontal" :step="1" 
                :disabled="true">
                <template #incrementbuttonicon>
                    <span class="pi pi-plus" />
                </template>
                <template #decrementbuttonicon>
                    <span class="pi pi-minus" />
                </template>
            </InputNumber>
        </div>
        <div class="flex flex-column w-full mb-3" v-if="currentRate && currentRate.exchange_percent != undefined">
            <span class="flex text-sm mr-2 mb-1">Задать новый обменный курс: </span>
            <InputNumber v-model="newRecalcRate" :minFractionDigits="1" :maxFractionDigits="9" locale="en-US" showButtons buttonLayout="horizontal" :step="1"
                :disabled="false">
                <template #incrementbuttonicon>
                    <span class="pi pi-plus" />
                </template>
                <template #decrementbuttonicon>
                    <span class="pi pi-minus" />
                </template>
            </InputNumber>
        </div>
        <template #footer>
            <div class="w-full mb-3 flex justify-content-between flex-wrap">
                <Button label="Изменить" icon="pi pi-check" iconPos="right" @click='UpdateRate()' :loading="loadingChanges" :disabled="loadingChanges" class="flex"/>
                <Button label="Закрыть" icon="pi pi-times" @click="closeDialog" outlined class="flex" autofocus severity="secondary" :loading="loadingChanges" :disabled="loadingChanges"/>
            </div>
        </template>
    </Dialog>

    <!--ИЗМЕНИТЬ ЛИМИТЫ-->
    <Dialog v-if="(isUserInGroup('admin') || isUserInGroup('manager'))" class="flex flex-column border-none" modal
        v-model:visible="popupLimits" 
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : 'max-w-30rem'">

        <template #header>
            <div class="flex flex-column w-full mb-3" v-if="currentRate">
                <span class="flex text-lg font-medium">Редактирование лимитов для курса {{currentRate.from_currency_code}} → {{currentRate.to_currency_code}}</span>
            </div>
        </template>

        <div class="flex flex-column w-full gap-4">
            <div class="flex flex-column w-full gap-2">
                <span class="flex text-lg font-medium">Переводы</span>

                <div class="flex  w-full gap-3 mb-3 flex-column xl:flex-row lg:flex-row">
                    <div class="flex flex-1 flex-column" v-if="editingLimits.transfer">
                        <span class="flex text-sm mb-1">Минимум: </span>
                        <InputNumber v-model="editingLimits.transfer.min" :minFractionDigits="0" :maxFractionDigits="0" locale="en-US" :step="1" mode="currency" :currency="(editingCurrency) ? editingCurrency : 'USD'" />
                    </div>
                    <div class="flex flex-1 flex-column" v-if="editingLimits.transfer">
                        <span class="flex text-sm mb-1">Максимум: </span>
                        <InputNumber v-model="editingLimits.transfer.max" :minFractionDigits="0" :maxFractionDigits="0" locale="en-US" :step="1" mode="currency" :currency="(editingCurrency) ? editingCurrency : 'USD'" />
                    </div>
                </div>

                <div class="flex flex-row w-full gap-3 mb-3">
                    <div class="flex flex-1 flex-column" v-if="editingLimits.transfer">
                        <span class="flex text-sm mb-1">Первый перевод (бесплатный): </span>
                        <InputNumber v-model="editingLimits.transfer.free" :minFractionDigits="0" :maxFractionDigits="0" locale="en-US" :step="1" mode="currency" :currency="(editingCurrency) ? editingCurrency : 'USD'" />
                    </div>
                </div>
            </div>
        </div>
        <div class="flex flex-column w-full gap-4">
            <div class="flex flex-column w-full gap-2">
                <span class="flex text-lg font-medium">Пополнения</span>
                <div class="flex  w-full gap-3 mb-3 flex-column xl:flex-row lg:flex-row">
                    <div class="flex flex-column w-full" v-if="editingLimits.topup">
                        <span class="flex text-sm mb-1">Минимум: </span>
                        <InputNumber v-model="editingLimits.topup.min" :minFractionDigits="0" :maxFractionDigits="0" locale="en-US" :step="1" mode="currency" :currency="(editingCurrency) ? editingCurrency : 'USD'"
                            :disabled="currentRate.type && currentRate.type!='origin'"/>
                    </div>
                    <div class="flex flex-column w-full" v-if="editingLimits.topup">
                        <span class="flex text-sm mb-1">Максимум: </span>
                        <InputNumber v-model="editingLimits.topup.max" :minFractionDigits="0" :maxFractionDigits="0" locale="en-US" :step="1" mode="currency" :currency="(editingCurrency) ? editingCurrency : 'USD'"
                            :disabled="currentRate.type && currentRate.type!='origin'"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex flex-column w-full gap-4">
            <div class="flex flex-column w-full gap-2">
                <span class="flex text-lg font-medium">Вывод</span>
                <div class="flex  w-full gap-3 mb-3 flex-column xl:flex-row lg:flex-row">
                    <div class="flex flex-column w-full" v-if="editingLimits.withdraw">
                        <span class="flex text-sm mb-1">Минимум: </span>
                        <InputNumber v-model="editingLimits.withdraw.min" :minFractionDigits="0" :maxFractionDigits="0" locale="en-US" :step="1" mode="currency" :currency="(editingCurrency) ? editingCurrency : 'USD'" />
                    </div>
                    <div class="flex flex-column w-full" v-if="editingLimits.withdraw">
                        <span class="flex text-sm mb-1">Максимум: </span>
                        <InputNumber v-model="editingLimits.withdraw.max" :minFractionDigits="0" :maxFractionDigits="0" locale="en-US" :step="1" mode="currency" :currency="(editingCurrency) ? editingCurrency : 'USD'" />
                    </div>
                </div>
            </div>
        </div>
        <div class="flex flex-column w-full gap-4">
            <div class="flex flex-column w-full gap-2">
                <span class="flex text-lg font-medium">Прием платежей</span>
                <div class="flex  w-full gap-3 mb-3 flex-column xl:flex-row lg:flex-row">
                    <div class="flex flex-column w-full" v-if="editingLimits.bill">
                        <span class="flex text-sm mb-1">Минимум: </span>
                        <InputNumber v-model="editingLimits.bill.min" :minFractionDigits="0" :maxFractionDigits="0" locale="en-US" :step="1" mode="currency" :currency="(editingCurrency) ? editingCurrency : 'USD'" />
                    </div>
                    <div class="flex flex-column w-full" v-if="editingLimits.bill">
                        <span class="flex text-sm mb-1">Максимум: </span>
                        <InputNumber v-model="editingLimits.bill.max" :minFractionDigits="0" :maxFractionDigits="0" locale="en-US" :step="1" mode="currency" :currency="(editingCurrency) ? editingCurrency : 'USD'" />
                    </div>
                </div>
            </div>
        </div>
    
        <template #footer>
            <div class="w-full mb-3 flex justify-content-between flex-wrap">
                <Button label="Изменить" icon="pi pi-check" iconPos="right" @click='UpdateLimits()' :loading="loadingChanges" :disabled="loadingChanges" class="flex"/>
                <Button label="Закрыть" icon="pi pi-times" @click="closeDialog" outlined class="flex" autofocus severity="secondary" :loading="loadingChanges" :disabled="loadingChanges"/>
            </div>
        </template>
        
    </Dialog>

    <!--ИЗМЕНИТЬ КОМИССИИ-->
    <Dialog v-if="(isUserInGroup('admin') || isUserInGroup('manager'))" class="flex flex-column border-none" modal
        v-model:visible="popupComs"
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : ''">

        <template #header>
            <div class="flex flex-column w-full mb-3" v-if="currentRate">
                <span class="flex text-lg font-medium">Редактирование комиссий для курса {{currentRate.from_currency_code}} → {{currentRate.to_currency_code}}</span>
            </div>
        </template>

        <div class="flex flex-column w-full gap-4">
            <!-- Transfer -->
            <div class="flex flex-column w-full gap-2">
                <span class="flex text-lg font-medium">Переводы</span>
                <div class="flex flex-row w-full gap-3 mb-2">
                    <div class="flex flex-column gap-1 surface-100 p-2 border-round-lg">
                        <span class="text-sm">Прием (фикс):</span>
                        <InputNumber v-model="editingComs.transfer.get.fix" :minFractionDigits="2" :maxFractionDigits="6" locale="en-US" :step="0.01" class="w-full" placeholder="Фикс"/>
                        <span class="text-sm">Прием (процент):</span>
                        <InputNumber v-model="editingComs.transfer.get.percent" :minFractionDigits="2" :maxFractionDigits="6" locale="en-US" :step="0.01" class="w-full mt-1" placeholder="%"/>
                    </div>
                    <div class="flex flex-column gap-1 surface-100 p-2 border-round-lg">
                        <span class="text-sm">Выплата (фикс):</span>
                        <InputNumber v-model="editingComs.transfer.send.fix" :minFractionDigits="2" :maxFractionDigits="6" locale="en-US" :step="0.01" class="w-full" placeholder="Фикс"/>
                        <span class="text-sm">Выплата (процент):</span>
                        <InputNumber v-model="editingComs.transfer.send.percent" :minFractionDigits="2" :maxFractionDigits="6" locale="en-US" :step="0.01" class="w-full mt-1" placeholder="%"/>
                    </div>
                    <div class="flex flex-column gap-1 surface-100 p-2 border-round-lg">
                        <span class="text-sm">Сервис (фикс):</span>
                        <InputNumber v-model="editingComs.transfer.service.fix" :minFractionDigits="2" :maxFractionDigits="6" locale="en-US" :step="0.01" class="w-full" placeholder="Фикс"/>
                        <span class="text-sm">Сервис (процент):</span>
                        <InputNumber v-model="editingComs.transfer.service.percent" :minFractionDigits="2" :maxFractionDigits="6" locale="en-US" :step="0.01" class="w-full mt-1" placeholder="%"/>
                    </div>
                </div>
            </div>
            <!-- Topup -->
            <div class="flex flex-column w-full gap-2">
                <span class="flex text-lg font-medium">Пополнения</span>
                <div class="flex flex-row w-full gap-3 mb-2">
                    <div class="flex flex-column gap-1 surface-100 p-2 border-round-lg">
                        <span class="text-sm">Прием (фикс):</span>
                        <InputNumber v-model="editingComs.topup.get.fix" :minFractionDigits="2" :maxFractionDigits="6" locale="en-US" :step="0.01" class="w-full" placeholder="Фикс"
                            :disabled="currentRate.type && currentRate.type!='origin'"/>
                        <span class="text-sm">Прием (процент):</span>
                        <InputNumber v-model="editingComs.topup.get.percent" :minFractionDigits="2" :maxFractionDigits="6" locale="en-US" :step="0.01" class="w-full mt-1" placeholder="%"
                            :disabled="currentRate.type && currentRate.type!='origin'"/>
                    </div>
                    <div class="flex flex-column gap-1 surface-100 p-2 border-round-lg">
                        <span class="text-sm">Сервис (фикс):</span>
                        <InputNumber v-model="editingComs.topup.service.fix" :minFractionDigits="2" :maxFractionDigits="6" locale="en-US" :step="0.01" class="w-full" placeholder="Фикс"
                            :disabled="currentRate.type && currentRate.type!='origin'"/>
                        <span class="text-sm">Сервис (процент):</span>
                        <InputNumber v-model="editingComs.topup.service.percent" :minFractionDigits="2" :maxFractionDigits="6" locale="en-US" :step="0.01" class="w-full mt-1" placeholder="%"
                            :disabled="currentRate.type && currentRate.type!='origin'"/>
                    </div>
                </div>
            </div>
            <!-- Withdraw -->
            <div class="flex flex-column w-full gap-2">
                <span class="flex text-lg font-medium">Вывод</span>
                <div class="flex flex-row w-full gap-3 mb-2">
                    <div class="flex flex-column gap-1 surface-100 p-2 border-round-lg">
                        <span class="text-sm">Выплата (фикс):</span>
                        <InputNumber v-model="editingComs.withdraw.send.fix" :minFractionDigits="2" :maxFractionDigits="6" locale="en-US" :step="0.01" class="w-full" placeholder="Фикс"
                            :disabled="currentRate.type && currentRate.type!='origin'"/>
                        <span class="text-sm">Выплата (процент):</span>
                        <InputNumber v-model="editingComs.withdraw.send.percent" :minFractionDigits="2" :maxFractionDigits="6" locale="en-US" :step="0.01" class="w-full mt-1" placeholder="%"
                            :disabled="currentRate.type && currentRate.type!='origin'"/>
                    </div>
                    <div class="flex flex-column gap-1 surface-100 p-2 border-round-lg">
                        <span class="text-sm">Сервис (фикс):</span>
                        <InputNumber v-model="editingComs.withdraw.service.fix" :minFractionDigits="2" :maxFractionDigits="6" locale="en-US" :step="0.01" class="w-full" placeholder="Фикс"
                            :disabled="currentRate.type && currentRate.type!='origin'"/>
                        <span class="text-sm">Сервис (процент):</span>
                        <InputNumber v-model="editingComs.withdraw.service.percent" :minFractionDigits="2" :maxFractionDigits="6" locale="en-US" :step="0.01" class="w-full mt-1" placeholder="%"
                            :disabled="currentRate.type && currentRate.type!='origin'"/>
                    </div>
                </div>
            </div>
            <!-- Bill -->
            <div class="flex flex-column w-full gap-2">
                <span class="flex text-lg font-medium">Прием платежей</span>
                <div class="flex flex-row w-full gap-3 mb-2">
                    <div class="flex flex-column gap-1 surface-100 p-2 border-round-lg">
                        <span class="text-sm">Прием (фикс):</span>
                        <InputNumber v-model="editingComs.bill.get.fix" :minFractionDigits="2" :maxFractionDigits="6" locale="en-US" :step="0.01" class="w-full" placeholder="Фикс"/>
                        <span class="text-sm">Прием (процент):</span>
                        <InputNumber v-model="editingComs.bill.get.percent" :minFractionDigits="2" :maxFractionDigits="6" locale="en-US" :step="0.01" class="w-full mt-1" placeholder="%"/>
                    </div>
                    <div class="flex flex-column gap-1 surface-100 p-2 border-round-lg">
                        <span class="text-sm">Выплата (фикс):</span>
                        <InputNumber v-model="editingComs.bill.send.fix" :minFractionDigits="2" :maxFractionDigits="6" locale="en-US" :step="0.01" class="w-full" placeholder="Фикс"/>
                        <span class="text-sm">Выплата (процент):</span>
                        <InputNumber v-model="editingComs.bill.send.percent" :minFractionDigits="2" :maxFractionDigits="6" locale="en-US" :step="0.01" class="w-full mt-1" placeholder="%"/>
                    </div>
                    <div class="flex flex-column gap-1 surface-100 p-2 border-round-lg">
                        <span class="text-sm">Сервис (фикс):</span>
                        <InputNumber v-model="editingComs.bill.service.fix" :minFractionDigits="2" :maxFractionDigits="6" locale="en-US" :step="0.01" class="w-full" placeholder="Фикс"/>
                        <span class="text-sm">Сервис (процент):</span>
                        <InputNumber v-model="editingComs.bill.service.percent" :minFractionDigits="2" :maxFractionDigits="6" locale="en-US" :step="0.01" class="w-full mt-1" placeholder="%"/>
                    </div>
                </div>
            </div>
        </div>
    
        <template #footer>
            <div class="w-full mb-3 flex justify-content-between flex-wrap">
                <Button label="Изменить" icon="pi pi-check" iconPos="right" @click='UpdateComs()' :loading="loadingChanges" :disabled="loadingChanges" class="flex"/>
                <Button label="Закрыть" icon="pi pi-times" @click="closeDialog" outlined class="flex" autofocus severity="secondary" :loading="loadingChanges" :disabled="loadingChanges"/>
            </div>
        </template>
    </Dialog>

    <!-- ИЗМЕНИТЬ СПИСОК ПЛАТЕЖНЫХ СИСТЕМ -->
    <Dialog v-if="(isUserInGroup('admin') || isUserInGroup('manager'))" class="flex flex-column border-none" modal
        v-model:visible="popupPaySystems"
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : ''">

        <template #header>
            <div class="flex flex-column w-full mb-3" v-if="currentRate">
                <span class="flex text-lg font-medium">Редактирование платежных систем для курса {{currentRate.from_currency_code}} → {{currentRate.to_currency_code}}</span>
            </div>
        </template>

        <div class="flex flex-column w-full gap-4">
            <div class="flex flex-column w-full gap-2">
                <span class="flex text-lg font-medium">Платежные системы приема</span>
                <MultiSelect v-model="editingPaySystems.pays_get_codes" :options="paySystems" optionLabel="label" optionValue="value" placeholder="Выберите платежные системы" class="w-full" :filter="true" />
            </div>
            <div class="flex flex-column w-full gap-2">
                <span class="flex text-lg font-medium">Платежные системы выплаты</span>
                <MultiSelect v-model="editingPaySystems.pays_send_codes" :options="paySystems" optionLabel="label" optionValue="value" placeholder="Выберите платежные системы" class="w-full" :filter="true" />
            </div>
        </div>

        <template #footer>
            <div class="w-full mb-3 flex justify-content-between flex-wrap">
                <Button label="Изменить" icon="pi pi-check" iconPos="right" @click='UpdatePaySystems()' :loading="loadingChanges" :disabled="loadingChanges" class="flex"/>
                <Button label="Закрыть" icon="pi pi-times" @click="closeDialog" outlined class="flex" autofocus severity="secondary" :loading="loadingChanges" :disabled="loadingChanges"/>
            </div>
        </template>
    </Dialog>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import BigNumber from 'bignumber.js'
import BanksEditor from '@/components/merchant/BanksEditor.vue'
import { CurrencyList} from '@/assets/js/classes/Currency.js'
import { PaymentSystemList } from '@/assets/js/classes/PaymentSystem.js'

export default {
    data() {
        return {
            rates: [],
            bankList: [],
            paySystems: [],
            rows: 20,
            skip: 0,
            totalRates: 0,
            popupAdd: false,
            popupActive: false,
            popupStock: false,
            popupRates: false,
            popupLimits: false,
            popupComs: false,
            popupPaySystems: false,
            loadingChanges: false,
            loadingRates: false,
            currentRate: {},
            currentSign: null,
            currentPercent: null,
            newRecalcRate: null,
            newRecalcRateInvert: null,
            columns: [
                {field: 'Лимиты', header: 'Лимиты'},
                {field: 'Банки', header: 'Банки'},
            ],
            selectedColumns: [],
            percent_signs: [
                'plus', 'minus'
            ],
            lazyParams: {
                first: 0,
                rows: 20,
                page: 0,
                sortField: null,
                sortOrder: null,
                filters: {},
            },
            types: ['origin', 'calculated', 'nulled'],
            types_of_stock: ['bybit', 'binance','htx', 'regular', 'rapira',  'manual'],
            currencies: [],
            currenciesCodes: [],
            filters: {
                id: {value: '', matchMode: 'contains'},
                type: {value: '', matchMode: 'contains'},
                from_currency_code: {value: '', matchMode: 'contains'},
                to_currency_code: {value: '', matchMode: 'contains'},
                stock_type: {
                    type: {value: '', matchMode: 'contains'},
                },
                from: {value: '', matchMode: 'contains'},
                to: {value: '', matchMode: 'contains'},
            },
            sort: {
                _id: -1,
            },
            stop: false,
            active_options: [
                {label: 'Активен', value: true},
                {label: 'Неактивен', value: false},
            ],
            closeBanks: false,

            editingLimits:{
                transfer: {
                    min: 0,
                    max: 0,
                    free: 0
                },
                topup: {
                    min: 0,
                    max: 0,
                },
                withdraw: {
                    min: 0,
                    max: 0,
                },
                bill: {
                    min: 0,
                    max: 0,
                },
            },
            editingComs:{
                transfer: {
                    get: {
                        fix: 0,
                        percent: 0
                    },
                    send: {
                        fix: 0,
                        percent: 0
                    },
                    service: {
                        fix: 0,
                        percent: 0
                    }
                },
                topup: {
                    get: {
                        fix: 0,
                        percent: 0
                    },
                    service: {
                        fix: 0,
                        percent: 0
                    }
                },
                withdraw: {
                    send: {
                        fix: 0,
                        percent: 0
                    },
                    service: {
                        fix: 0,
                        percent: 0
                    }
                },
                bill: {
                    get: {
                        fix: 0,
                        percent: 0
                    },
                    send: {
                        fix: 0,
                        percent: 0
                    },
                    service: {
                        fix: 0,
                        percent: 0
                    }
                },
            },
            editingPaySystems: {
                pays_get_codes: [],
                pays_send_codes: []
            },
            editingCurrency: null,
            stockTypes: [
                {label: 'Ручной', value: 'manual'},
                {label: 'Обычный', value: 'regular'},
                {label: 'Bybit P2P', value: 'bybit'},
                {label: 'Binance P2P', value: 'binance'},
                {label: 'HTX P2P', value: 'htx'},
                {label: 'Rapira', value: 'rapira'},
                {label: 'Binance Стакан', value: 'binance_stock'},
            ],
            stockPeriods: [
                {label: 'Каждый час', value: '1h'},
                {label: 'Каждые 30 минут', value: '30m'},
                {label: 'Каждые 20 минут', value: '20m'},
                {label: 'Каждые 10 минут', value: '10m'},
            ],
            formatedStockProps: '',
            stockDesc: this.getStockDesc('bybit'),
            sets: [
                {name: 'Парсинг', value: 'Парсинг'},
                {name: 'Платежки', value: 'Платежки'},
                {name: 'Банки', value: 'Банки'},
                {name: 'Лимиты', value: 'Лимиты'},
                {name: 'Комиссии', value: 'Комиссии'},
            ],
            set: []
        }
    },
    components: {
        BanksEditor
    },
    watch: {
        popupRates(val) {
            if(!val){
                this.currentRate = {}
                this.currentSign = null
                this.currentPercent = null
                this.newRecalcRate = null
                this.newRecalcRateInvert = null
            }
        },
        newRecalcRate(val){
            this.recalcCurrentRate(val)
        },
        set: {
            handler(val) { 
                this.selectedColumns = []
                for (let i = 0; i < val.length; i++) {
                    let v = val[i].value
                    if(Array.isArray(v)) this.selectedColumns = this.selectedColumns.concat(v)
                    else this.selectedColumns.push(v)
                }
            },
            immediate: true
        },
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        screenSize() { return this.$store.getters.StateScreenSize },
    },
    methods: {
        popupAddRate(){
            this.currentRate = {}
            this.popupAdd = true
        },
        async resetFilter(){
            this.filters = {
                id: {value: '', matchMode: 'contains'},
                type: {value: '', matchMode: 'contains'},
                from_currency_code: {value: '', matchMode: 'contains'},
                to_currency_code: {value: '', matchMode: 'contains'},
                stock_type: {value: '', matchMode: 'contains'},
                from: {value: '', matchMode: 'contains'},
                to: {value: '', matchMode: 'contains'},
            }
            this.selectedColumns = []
            this.set = []
            this.LoadRates()
        },  
        EditActive(id){
            if(!id) return
            this.currentRate = this.rates.find(x => x.id == id)
            if(!this.currentRate){
                this.showMess('warn', 'Внимание', 'Не найден курс')
                return false
            }
            this.popupActive = true
        },
        EditStock(id){
            if(!id) return
            this.currentRate = this.rates.find(x => x.id == id)
            if(!this.currentRate){
                this.showMess('warn', 'Внимание', 'Не найден курс')
                return false
            }
            this.popupStock = true
            this.setStockPropsByRate(id)
        },
        async UpdateStock(){
            if(!this.currentRate) return
            if(!this.currentRate.id) return
            if(!this.currentRate.stock) return
            if(!this.currentRate.stock.type) return false
            this.loadingChanges = true
            const data = {
                stock: {
                    type: this.currentRate.stock.type,
                    period: this.currentRate.stock.period,
                    props: this.unformatStockProps(this.formatedStockProps)
                }
            }
            await this.Update(this.currentRate.id, data).then(res => {
                if(res.result){
                    this.showMess('success', 'Успех', 'Парсинг обновлен')
                    this.popupStock = false
                    this.LoadRates()
                }else{
                    const err = (res && res.errors && res.errors[0]) ? res.errors[0] : 'Неизвестная ошибка'
                    this.showMess('error', 'Ошибка', err)
                }
            })
            this.loadingChanges = false
        },
        setStockTemplate(type){
            if(!type) return
            let props = {}
            switch(type){
                case 'bybit':
                    props = {
                        "payMethods": [ 
                            "1",
                            "2",
                            "3"
                        ],
                        "authMaker": 1,
                        "countAds": 10,                   
                        "minAmount": 100000,
                        "maxAmount": 9999999999,
                        "recentOrderNum": 3000,
                        "recentExecuteRate": 90
                    }
                    this.stockDesc = this.getStockDesc('bybit')
                break;
                case 'binance':
                    props = {
                        "payMethods": [ 
                            "BANK"
                        ],
                        "countAds": 10,
                        "minSingleTransAmount": 100,
                        "maxSingleTransAmount": 99999999,
                        "monthOrderCount": 500,
                        "monthFinishRate": 0.8
                    }
                    this.stockDesc = this.getStockDesc('binance')
                break;
                case 'htx':
                    props = {
                        "payMethods": [ 
                            "2",
                            "3"
                        ],
                        "countAds": 10,
                        "minTradeLimit": 1000,
                        "maxTradeLimit": 999999,
                        "tradeMonthTimes": 100,
                        "orderCompleteRate": 80,
                        "totalTradeOrderCount": 90
                    }
                    this.stockDesc = this.getStockDesc('htx')
                break;                
                default:
                    this.stockDesc = ''
                break;
            }
            this.formatedStockProps = JSON.stringify(props, null, 2);
        },
        getStockDesc(type){
            if(!type) return ''
            switch(type){
                case 'bybit':
                    return `Шаблон Bybit: <br><br>
                    payMethods: ["17","37","115"],  // (обяз.) методы оплаты для фильтрации <br>
                    authMaker: 1,                   // требовать верификацию <br>
                    countAds: 10,                   // количество объявлений для расчета курса <br>
                    minAmount: 100000,              // минимальная сумма сделки <br>
                    maxAmount: 9999999999,          // максимальная сумма сделки <br>
                    recentOrderNum: 3000,           // количество последних ордеров <br>
                    recentExecuteRate: 90           // процент успешных сделок <br>`;
                case 'binance':
                    return `Шаблон Binance: <br><br>
                    payMethods: ['BANK'],               // (обяз.) методы оплаты для фильтрации <br>
                    countAds: 10,                       // количество объявлений для расчета курса <br>
                    minSingleTransAmount: 100,          // минимальная сумма сделки <br>
                    maxSingleTransAmount: 99999999,     // максимальная сумма сделки <br>
                    monthOrderCount: 500,               // количество сделок за месяц <br>
                    monthFinishRate: 0.8                // процент завершенных заказов трейдера <br>`;
                case 'htx':
                    return `Шаблон HTX: <br><br>
                    payMethods: ['2', '3'],       // (обяз.) все методы оплаты <br>
                    countAds: 10,                 // количество объявлений для расчета курса <br>
                    minTradeLimit: 1000,          // минимальный лимит сделки <br>
                    maxTradeLimit: 999999,        // максимальный лимит сделки <br>
                    tradeMonthTimes: 100,         // количество сделок за месяц <br>
                    orderCompleteRate: 80,        // процент завершенных заказов <br>
                    totalTradeOrderCount: 90     // общее количество завершенных заказов трейдера <br>`;
                default:
                    return ''
            }
        },
        setStockPropsByRate(id){
            if(!id) return
            this.popupStock = true
            this.currentRate = this.rates.find(x => x.id == id)
            if(!this.currentRate){
                this.showMess('warn', 'Внимание', 'Не найден курс')
                return false
            }
            this.formatedStockProps = JSON.stringify(this.currentRate.stock.props, null, 2);
        },
        unformatStockProps(){
            if(!this.formatedStockProps) return
            try {
                return JSON.parse(this.formatedStockProps)
            } catch (error) {
                this.showMess('error', 'Ошибка', 'Не удалось распарсить свойства')
                return null
            }
        },
        getExchangePercent(obj) {
            if(!obj) return 0
            if(!obj.type) return 0
            if(obj.type=='calculated' || obj.type=='nulled') return ''
            return (obj.exchange_percent) ? obj.exchange_percent : 0
        },
        getExchangeRate(obj) {
            if(!obj) return 0
            if(!obj.type) return 0
            switch(obj.type){
                case 'origin':
                    return (obj.rate) ? obj.rate : 0;
                case 'nulled':
                    return '';
                case 'calculated':
                    let left_rate = this.rates.find(item => {
                        return item.from_currency_code == obj.from_currency_code && item.type == 'origin'
                    })
                    let right_rate = this.rates.find(item => {
                        return item.to_currency_code == obj.to_currency_code && item.type == 'origin'
                    })
                    if(left_rate && right_rate){
                        let b_left = new BigNumber(left_rate.rate)
                        let b_right = new BigNumber(right_rate.rate)
                        let recalc_rate = b_right.multipliedBy(b_left)
                        return recalc_rate.toFixed(9) // точность 3 знака после запятой
                    } else return 'не найден origin курс'
                default:
                    return 'неизвестный тип курса';
            }
        },
        async UpdateBanks(val){
            if(!val) return
            if(!val.id) return
            if(!val.bank_codes) return false
            if(!val.type) return false
            this.closeBanks = true
            this.loadingChanges = true
            const data = (val.type=='get') ? {get_bank_codes: val.bank_codes} : {send_bank_codes: val.bank_codes}
            await this.Update(val.id, data).then(res => {
               
                if(res){
                    this.showMess('success', 'Успех', 'Банки обновлены')
                    this.currentRate = {}
                    this.LoadRates()
                }else{
                    const err = (res && res.errors && res.errors[0]) ? res.errors[0] : 'Неизвестная ошибка'
                    this.showMess('error', 'Ошибка', err)
                }
            })
            this.loadingChanges = false
        },
        EditPaySystems(id){
            if(!id) return
            this.popupPaySystems = true
            this.currentRate = this.rates.find(x => x.id == id)
            if(!this.currentRate){
                this.showMess('warn', 'Внимание', 'Не найден курс')
                return false
            }
            this.editingPaySystems = {
                pays_get_codes: (this.currentRate.pays_get_codes) ? this.currentRate.pays_get_codes : [],
                pays_send_codes: (this.currentRate.pays_send_codes) ? this.currentRate.pays_send_codes : []
            }
        },
        async UpdatePaySystems(){
            if(!this.currentRate) return
            if(!this.currentRate.id) return
            this.loadingChanges = true
            const data = {
                pays_get_codes: this.editingPaySystems.pays_get_codes,
                pays_send_codes: this.editingPaySystems.pays_send_codes
            }
            await this.Update(this.currentRate.id, data).then(res => {
                if(res.result){
                    this.showMess('success', 'Успех', 'Платежные системы обновлены')
                    this.popupPaySystems = false
                    this.LoadRates()
                }else{
                    const err = (res && res.errors && res.errors[0]) ? res.errors[0] : 'Неизвестная ошибка'
                    this.showMess('error', 'Ошибка', err)
                }
            })
            this.loadingChanges = false
        },
        EditLimits(id){
            if(!id) return
            this.popupLimits = true
            this.currentRate = this.rates.find(x => x.id == id)
            if(!this.currentRate){
                this.showMess('warn', 'Внимание', 'Не найден курс')
                return false
            }
            this.editingLimits = {
                transfer: {
                    min: (this.currentRate.limits && this.currentRate.limits.transfer) ? this.currentRate.limits.transfer.min : 0,
                    max: (this.currentRate.limits && this.currentRate.limits.transfer) ? this.currentRate.limits.transfer.max : 0,
                    free: (this.currentRate.limits && this.currentRate.limits.transfer) ? this.currentRate.limits.transfer.free : 0
                },
                topup: {
                    min: (this.currentRate.limits && this.currentRate.limits.topup) ? this.currentRate.limits.topup.min : 0,
                    max: (this.currentRate.limits && this.currentRate.limits.topup) ? this.currentRate.limits.topup.max : 0,
                },
                withdraw: {
                    min: (this.currentRate.limits && this.currentRate.limits.withdraw) ? this.currentRate.limits.withdraw.min : 0,
                    max: (this.currentRate.limits && this.currentRate.limits.withdraw) ? this.currentRate.limits.withdraw.max : 0,
                },
                bill: {
                    min: (this.currentRate.limits && this.currentRate.limits.bill) ? this.currentRate.limits.bill.min : 0,
                    max: (this.currentRate.limits && this.currentRate.limits.bill) ? this.currentRate.limits.bill.max : 0,
                },
            }
            this.editingCurrency = (this.currentRate.from_currency_code) ? this.getValidCurrency(this.currentRate.from_currency_code) : null
        },
        EditComs(id){
            if(!id) return
            this.popupComs = true
            this.currentRate = this.rates.find(x => x.id == id)
            console.log('edit coms',this.currentRate)
            if(!this.currentRate){
                this.showMess('warn', 'Внимание', 'Не найден курс')
                return false
            }
            this.editingComs = {
                transfer: {
                    get: {
                        fix: (this.currentRate.comissions && this.currentRate.comissions.transfer && this.currentRate.comissions.transfer.get) ? this.currentRate.comissions.transfer.get.fix : 0,
                        percent: (this.currentRate.comissions && this.currentRate.comissions.transfer && this.currentRate.comissions.transfer.get) ? this.currentRate.comissions.transfer.get.percent : 0
                    },
                    send: {
                        fix: (this.currentRate.comissions && this.currentRate.comissions.transfer && this.currentRate.comissions.transfer.send) ? this.currentRate.comissions.transfer.send.fix : 0,
                        percent: (this.currentRate.comissions && this.currentRate.comissions.transfer && this.currentRate.comissions.transfer.send) ? this.currentRate.comissions.transfer.send.percent : 0
                    },
                    service: {
                        fix: (this.currentRate.comissions && this.currentRate.comissions.transfer && this.currentRate.comissions.transfer.service) ? this.currentRate.comissions.transfer.service.fix : 0,
                        percent: (this.currentRate.comissions && this.currentRate.comissions.transfer && this.currentRate.comissions.transfer.service) ? this.currentRate.comissions.transfer.service.percent : 0   
                    }
                },
                topup: {
                    get: {
                        fix: (this.currentRate.comissions && this.currentRate.comissions.topup && this.currentRate.comissions.topup.get) ? this.currentRate.comissions.topup.get.fix : 0,
                        percent: (this.currentRate.comissions && this.currentRate.comissions.topup && this.currentRate.comissions.topup.get) ? this.currentRate.comissions.topup.get.percent : 0
                    },
                    service: {
                        fix: (this.currentRate.comissions && this.currentRate.comissions.topup && this.currentRate.comissions.topup.service) ? this.currentRate.comissions.topup.service.fix : 0,
                        percent: (this.currentRate.comissions && this.currentRate.comissions.topup && this.currentRate.comissions.topup.service) ? this.currentRate.comissions.topup.service.percent : 0   
                    }
                },
                withdraw: {
                    send: {
                        fix: (this.currentRate.comissions && this.currentRate.comissions.withdraw && this.currentRate.comissions.withdraw.send) ? this.currentRate.comissions.withdraw.send.fix : 0,
                        percent: (this.currentRate.comissions && this.currentRate.comissions.withdraw && this.currentRate.comissions.withdraw.send) ? this.currentRate.comissions.withdraw.send.percent : 0
                    },
                    service: {
                        fix: (this.currentRate.comissions && this.currentRate.comissions.withdraw && this.currentRate.comissions.withdraw.service) ? this.currentRate.comissions.withdraw.service.fix : 0,
                        percent: (this.currentRate.comissions && this.currentRate.comissions.withdraw && this.currentRate.comissions.withdraw.service) ? this.currentRate.comissions.withdraw.service.percent : 0
                    },
                },
                bill: {
                    get: {
                        fix: (this.currentRate.comissions && this.currentRate.comissions.bill && this.currentRate.comissions.bill.get) ? this.currentRate.comissions.bill.get.fix : 0,
                        percent: (this.currentRate.comissions && this.currentRate.comissions.bill && this.currentRate.comissions.bill.get) ? this.currentRate.comissions.bill.get.percent : 0
                    },
                    send: {
                        fix: (this.currentRate.comissions && this.currentRate.comissions.bill && this.currentRate.comissions.bill.send) ? this.currentRate.comissions.bill.send.fix : 0,
                        percent: (this.currentRate.comissions && this.currentRate.comissions.bill && this.currentRate.comissions.bill.send) ? this.currentRate.comissions.bill.send.percent : 0
                    },
                    service: {
                        fix: (this.currentRate.comissions && this.currentRate.comissions.bill && this.currentRate.comissions.bill.service) ? this.currentRate.comissions.bill.service.fix : 0,
                        percent: (this.currentRate.comissions && this.currentRate.comissions.bill && this.currentRate.comissions.bill.service) ? this.currentRate.comissions.bill.service.percent : 0   
                    }
                }
            }
        },
        UpdateActive(){
            if(!this.currentRate) return
            if(!this.currentRate.id) return
            if(this.currentRate.active==undefined) return false
            this.loadingChanges = true
            const data = {
                active: this.currentRate.active
            }
            this.Update(this.currentRate.id, data).then(res => {
                if(res.result){
                    this.showMess('success', 'Успех', 'Статус обновлен')
                    this.popupActive = false
                    this.LoadRates()
                }else{
                    const err = (res && res.errors && res.errors[0]) ? res.errors[0] : 'Неизвестная ошибка'
                    this.showMess('error', 'Ошибка', err)
                }
            })
            this.loadingChanges = false
        },
        async UpdateLimits(){
            if(!this.currentRate) return
            if(!this.currentRate.id) return
            if(!this.editingLimits) return
            if(!this.editingLimits.transfer) return
            if(!this.editingLimits.topup) return
            if(!this.editingLimits.withdraw) return
            if(!this.editingLimits.bill) return
            this.loadingChanges = true
            const data = {
                limits: {
                    transfer: this.editingLimits.transfer,
                    topup: this.editingLimits.topup,
                    withdraw: this.editingLimits.withdraw,
                    bill: this.editingLimits.bill,
                }
            }
            await this.Update(this.currentRate.id, data).then(res => {
                if(res.result){
                    this.showMess('success', 'Успех', 'Лимиты обновлены')
                    this.popupLimits = false
                    this.currentRate = {}
                    this.LoadRates()
                }else{
                    const err = (res && res.errors && res.errors[0]) ? res.errors[0] : 'Неизвестная ошибка'
                    this.showMess('error', 'Ошибка', err)
                }
            })
            this.loadingChanges = false
        },
        async UpdateComs(){
            if(!this.currentRate) return
            if(!this.currentRate.id) return
            if(!this.editingComs) return
            this.loadingChanges = true
            const data = {
                comissions: this.editingComs
            }
            await this.Update(this.currentRate.id, data).then(res => {
                if(res.result){
                    this.showMess('success', 'Успех', 'Комиссии обновлены')
                    this.popupComs = false
                    this.currentRate = {}
                    this.LoadRates()
                }else{
                    const err = (res && res.errors && res.errors[0]) ? res.errors[0] : 'Неизвестная ошибка'
                    this.showMess('error', 'Ошибка', err)
                }
            })
            this.loadingChanges = false
        },
        EditRate(id){
            this.popupRates = true
            this.currentSign = null
            this.currentRate = this.rates.find(x => x.id == id)
            if(!this.currentRate){
                this.showMess('warn', 'Внимание', 'Не найден курс')
                return false
            }
            this.currentSign = (this.currentRate.exchange_percent >= 0) ? 'plus' : 'minus'
            this.currentPercent = Math.abs(this.currentRate.exchange_percent)
            this.newRecalcRate = (this.currentRate.rate) ? this.currentRate.rate : 0
        },
        isGreaterThanOne(val){
            if(!val) return false
            let f = new BigNumber(val)
            return f.isGreaterThan(1)
        },
        isLessThanOne(val){
            if(!val) return false
            let f = new BigNumber(val)
            return f.isLessThanOrEqualTo(1)
        },
        recalcCurrentRate(val){
            const originRate = (this.currentRate.rate_origin) ? new BigNumber(this.currentRate.rate_origin) : 0
            if(!originRate) return
            let percent = new BigNumber(0)
            const newRate = (val) ? new BigNumber(val) : 0
            if(originRate.isEqualTo(0) || newRate.isEqualTo(0)) return
            if(newRate.isGreaterThan(originRate)){
                percent = newRate.minus(originRate).dividedBy(originRate)
                this.currentSign = 'plus'
            }else{
                percent = originRate.minus(newRate).dividedBy(originRate)
                this.currentSign = 'minus'
            }
            if(percent.isEqualTo(0)) return
            if(percent.isNaN()) return
            percent = percent.toFixed(9)
            this.currentPercent = percent
            this.newRecalcRateInvert = this.getReverceRate(newRate.toFixed(9))
            this.stop = true
        },
        recalcCurrentRateInvert(val){
            let rate = (this.currentRate.rate_origin) ? new BigNumber(this.currentRate.rate_origin) : 0
            if(!rate) return
            let percent = new BigNumber(0)
            let one = new BigNumber(1)
            let invert = (val) ? new BigNumber(val) : 0
            if(rate.isEqualTo(0) || invert.isEqualTo(0)) return

            let recalc = one.dividedBy(invert)
            if(recalc.isGreaterThan(rate)){
                let d = rate.dividedBy(recalc)
                percent = one.minus(d)
                this.currentSign = 'plus'
            }else{
                let d = recalc.dividedBy(rate)
                percent = one.minus(d)
                this.currentSign = 'minus'
            }
            percent = percent.toFixed(9)
            this.currentPercent = percent
            this.stop = true
        },
        isUserInGroup: function (type) { 
            return this.helper.isUserInGroup(type, this.$store.getters.StateGroups)
        },
        get_short_id(value){
            return this.helper.get_short_id(value)
        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: 'Скопировано', detail: text, life: 1000 })
        },
        onToggle: function (e) {
            if(e.length>0){
                this.selectedColumns = e
            } else {
                this.selectedColumns = []
            }
        },
        onPage(event) {
            this.lazyParams = event
            // this.LoadRates().then(()=>{})
        },
        onSort(event) {
            this.lazyParams = event
            // this.LoadRates().then(()=>{})
        },
        onFilter(event) {
            this.lazyParams.filters = this.filters
            // this.LoadRates().then(()=>{})
        },
        onRowSelect() {
            this.selectAll = this.selectedCustomers.length === this.totalRates
        },
        onRowUnselect() {
            this.selectAll = false;
        },
        getReverceRate(rate){
            return this.helper.get_reverce_rate(rate)
        },
        getClientRate(obj, type) {
            if (!obj) return 0;
            if (!type) return 0;
            if (!obj.rate) return 0;
            if (!obj.type || obj.type === 'nulled') return '-';
            const one = new BigNumber(1);
            let rate = this.getExchangeRate(obj);
            rate = new BigNumber(rate);
            if (!rate || rate.isEqualTo(0)) return 0;

            // Извлечение комиссий по новой схеме
            const coms = obj.comissions && obj.comissions[type]
                ? {
                    percent: new BigNumber(obj.comissions[type].percent || 0),
                    fix: new BigNumber(obj.comissions[type].fix || 0),
                }
                : { percent: new BigNumber(0), fix: new BigNumber(0) };

            // Применение процентной комиссии
            rate = rate.multipliedBy(one.minus(coms.percent));

            // Применение фиксированной комиссии
            if (coms.fix.isGreaterThan(0)) {
                rate = rate.minus(coms.fix.dividedBy(one));
            }

            if (rate.isLessThan(1)) rate = one.dividedBy(rate);
            return rate.toFixed(2);
        },
        closeDialog(){
            this.popupAdd = false
            this.popupActive = false
            this.popupRates = false
            this.popupLimits = false
            this.popupStock = false
            this.popupComs = false
            this.popupPaySystems = false
            this.formatStockProps = {}
            this.currentRate = {}
        },
        formatDate(date) {
            return this.helper.format_date(date)
        },
        getCurImage(code){
            return this.helper.GetCurrencyImage(code, this.currencies)
        },
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        get_format_amount(amount, currency){
            if(!amount) return '–'
            return this.helper.format_amount(amount, currency)
        },
        getFormatPercent(percent, digits=2){
            if(!percent) return '–'
            return (percent*100).toFixed(digits)+'%'
        },
        getFormatCom(object, transferType, direction){
            const comissionPercent = object.comissions && object.comissions[transferType] ? object.comissions[transferType][direction].percent : 0
            const comissionFix = object.comissions && object.comissions[transferType] ? object.comissions[transferType][direction].fix : 0
            let result = ''
            if(!comissionPercent && !comissionFix) result = '–'
            if(!comissionPercent) result = `${comissionFix}`
            if(!comissionFix) result = this.getFormatPercent(comissionPercent)
            return result
        },
        getValidCurrency(code) {
            return this.helper.GetValidCurrency(code)
        },
        async UpdateRate(){
            this.loadingChanges = true
            if(!this.currentRate.id || this.currentRate.id == null){
                this.showMess('warn', 'Внимание', 'Не выбран курс')
                this.loadingChanges = false
                return false
            }

            if(!this.currentSign || this.currentSign == ''){
                this.showMess('warn', 'Внимание', 'Не выбран знак')
                this.loadingChanges = false
                return false
            }

            if(!this.currentPercent || this.currentPercent == ''){
                this.showMess('warn', 'Внимание', 'Не выбран процент')
                this.loadingChanges = false
                return false
            }

            let percent = this.currentPercent
            if(this.currentSign == 'minus') percent = -percent
            
            const data = {
                exchange_percent: percent
            }
            await this.Update(this.currentRate.id, data).then(res => {
                if(res.result){
                    this.showMess('success', 'Успех', 'Курс обновлен')
                    this.popupRates = false
                    this.currentRate = {}
                    this.LoadRates()
                }else{
                    if(res.errors && res.errors[0])this.showMess('error', 'Ошибка', res.errors[0])
                    else this.showMess('error', 'Ошибка', 'Не удалось обновить курс')
                }
            })
            this.loadingChanges = false
        },
        async Update(id, data){
            if(!id || id == null) return {result: false, errors: ['Не выбран ID курса']}
            if(!data || data == null) return {result: false, errors: ['Не выбраны данные']}
            try {
                return await this.connect.rate_upd_by_admin(id, data).then(res=>{
                    if(res.result) return {result: true}
                    else return {result: false, errors: res.errors}
                })
            } catch (error) {
                console.log('error', error)
                return {result: false, errors: ['Ошибка при обновлении курса']}
            }
        },
        async AddRate(){
            if(!this.currentRate) return
            if(!this.currentRate.type || this.currentRate.type == ''){
                this.showMess('warn', 'Внимание', 'Не выбран тип курса')
                this.loadingChanges = false
                return false
            }
            if(!this.currentRate.from_currency_code || this.currentRate.from_currency_code == ''){
                this.showMess('warn', 'Внимание', 'Не выбрана валюта приема')
                this.loadingChanges = false
                return false
            }

            if(!this.currentRate.to_currency_code || this.currentRate.to_currency_code == ''){
                this.showMess('warn', 'Внимание', 'Не выбрана валюта выплаты')
                this.loadingChanges = false
                return false
            }

            if(!this.currentRate.rate || this.currentRate.rate == ''){
                this.showMess('warn', 'Внимание', 'Не выбран курс')
                this.loadingChanges = false
                return false
            }

            this.loadingChanges = true

            const data = {
                type: this.currentRate.type,
                from_currency_code: this.currentRate.from_currency_code,
                to_currency_code: this.currentRate.to_currency_code,
                rate: this.currentRate.rate
            }
            await this.connect.rate_add_by_admin(data).then(res => {
                if(res.result){
                    this.showMess('success', 'Успех', 'Курс добавлен')
                    this.popupAdd = false
                    this.currentRate = {}
                    this.LoadRates()
                }else{
                    if(res.errors && res.errors[0])this.showMess('error', 'Ошибка', res.errors[0])
                    else this.showMess('error', 'Ошибка', 'Не удалось добавить курс')
                }
            })
            this.loadingChanges = false
        },
        async LoadRates(){
            this.loadingRates = true
            this.rates = []
            window.scrollTo({ top: 0, behavior: 'smooth' })
            try {
                const rates = await this.connect.get_admin_rates().then(res => res)
                if (rates.result) {
                    this.rates = rates.data
                    this.totalRates = rates.total
                }
                else{
                    this.showMess('error', 'Ошибка', 'Не удалось загрузить курсы')
                    this.rates = []
                }
            } catch (error) {
                console.log('error', error)
                this.showMess('error', 'Ошибка', 'Не удалось загрузить курсы')
                this.rates = []
            }
            this.loadingRates = false
        },
        async GetCurrencyList(){
            const resCurrencies = await CurrencyList.GetList(this.$store).then(r=>r)
            if(!resCurrencies) return
            this.currencies = resCurrencies
            this.currenciesCodes = resCurrencies.map(c => c.code)
        },
        async GetPaymentSystemList(){
            const resPaySystems = await PaymentSystemList.GetList(this.$store).then(r=>r)
            if(!resPaySystems) return
            for(const ps of resPaySystems){
                this.paySystems.push({
                    label: (ps.titles && ps.titles['ru']) ? `${ps.titles['ru']} (${ps.code})` : ps.code,
                    value: ps.code
                })
            }
        }
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        this.lazyParams = {
            first: 0,
            rows: 20,
            page: 0,
            sortField: null,
            sortOrder: null,
            filters: this.filters,
        };
        await this.LoadRates().then(()=>{})
        await this.GetCurrencyList().then(()=>{})
        await this.GetPaymentSystemList().then(()=>{})
    },
}
</script>